import React from 'react';

import { Tabs, Tab } from '@mui/material';
import { v4 as uuid } from 'uuid';

import {
  COLOR_ON_SURFACE_OUTLINE_OUTLINE_ENABLED,
  COLOR_ON_SURFACE_TEXT_ON_SURFACE_TEXT,
  COLOR_ON_SURFACE_TEXT_ON_SURFACE_TEXT_VARIANT
} from '../../constants/colors';
import { ITooltip } from '../../interfaces/global';
import CustomTooltip from '../CustomTooltip/CustomTooltip';

import './TabBarNE.scss';

interface TabBarNEProps {
  tabItems: string[];
  value: number;
  tooltip?: ITooltip;
  action: (event: React.ChangeEvent<unknown>, newValue: number) => void;
}

const customStyles = {
  root: {
    width: '100%'
  },
  tabRoot: {
    minWidth: '85px',
    borderBottom: '2px solid ' + COLOR_ON_SURFACE_OUTLINE_OUTLINE_ENABLED,
    fontFamily: 'Roboto',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '21px',
    bottom: '1px',
    color: COLOR_ON_SURFACE_TEXT_ON_SURFACE_TEXT_VARIANT,
    textTransform: 'none',
    padding: '0px'
  },
  tab: {
    '& .MuiTab-wrapper': {
      height: '100%'
    }
  },
  selected: {
    color: COLOR_ON_SURFACE_TEXT_ON_SURFACE_TEXT
  },
  indicator: {
    backgroundColor: COLOR_ON_SURFACE_TEXT_ON_SURFACE_TEXT_VARIANT,
    height: '6px',
    borderRadius: '7px'
  }
};

const TabBarNE = ({ tabItems, action, value, tooltip }: TabBarNEProps) => {
  return (
    <Tabs
      value={value}
      onChange={action}
      indicatorColor="primary"
      textColor="inherit"
      variant="fullWidth"
      sx={{ root: customStyles.root, indicator: customStyles.indicator }}
    >
      {tabItems.map((item, index) => (
        <Tab
          wrapped
          disableRipple
          key={`tab-item-${item}-${uuid()}`}
          sx={{ root: customStyles.tabRoot, selected: customStyles.selected, wrapped: customStyles.tab }}
          label={
            tooltip ? (
              <CustomTooltip
                tooltipTitle={<div className="tooltip-text"> {tooltip.text[index]} </div>}
                placement={tooltip?.placement}
                key={`tab-item-${item}-${uuid()}`}
              >
                <span className="button-text-container">{item}</span>
              </CustomTooltip>
            ) : (
              <div className="tab-text-container">{item}</div>
            )
          }
        />
      ))}
    </Tabs>
  );
};

export default TabBarNE;
